import { render, staticRenderFns } from "./emptylist.vue?vue&type=template&id=b8ab9b14&scoped=true"
import script from "./emptylist.vue?vue&type=script&lang=js"
export * from "./emptylist.vue?vue&type=script&lang=js"
import style0 from "./emptylist.vue?vue&type=style&index=0&id=b8ab9b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ab9b14",
  null
  
)

export default component.exports